/* Copyright (c) 2023 MOCA Systems, Inc.  All rights reserved. */

/**
 * This Enum Indicates the signup method the user used to sign up. When set to 'authentication handler',
 * it indicates that the user was generated through the Firebase blocking authentication handler,
 * suggesting that the user hasn't completed their signup process yet.
 */
export enum UserSignUpMethod {
	AuthenticationHandler = 'authentication handler',
	Invite = 'invite',
	RallyPoint = 'rally point',
	SelfRegister = 'self register',
}
